import styled from 'styled-components';
import { Card } from 'antd';

export const StyledCard = styled(Card)`
  height: 300px;

  .active-event {
    background-color: #f1f7ff;
  }

  .ant-card-body {
    padding: 5px 24px;
  }

  .ant-card-head {
    border-bottom: 0;
  }

  .ant-descriptions {
    tr.ant-descriptions-row:nth-child(odd) th {
      padding-bottom: 0;
    }

    tr.ant-descriptions-row:nth-child(even) .ant-descriptions-item-container {
      margin-top: -5px;
    }
  }
`;

export const AlertTitle = styled.div`
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  width: 50%;
  display: inline-block;
  vertical-align: bottom;
`;
